import React from "react";
import * as ButtonStyles from "../../../../styles/v2/lexus/components/Button";
import * as Text from "../../../../styles/v2/lexus/utilities/Text";
import { IconWrapper, UspIconWrapper } from "../../../../styles/v2/lexus/globals/IconWrapper";
import {
    IconArrowRight,
    IconPhone,
    IconChevronLeft,
    IconReserve,
    IconCartV2,
    IconCard,
    IconInsurance,
    IconMarker,
} from "../../../../styles/v2/lexus/globals/Icon";
import { LineClamp } from "../../../../styles/v2/lexus/utilities/Lineclamp";

export enum CtaIcon {
    Buy = "buy",
    Reserve = "reserve",
    Dealer = "dealer",
    Phone = "phone",
    Back = "back",
    Finance = "finance",
    Insurance = "insurance",
}

type ButtonProps = {
    key?: number;
    href?: string;
    onClick?: (event: any) => void;
    disabled?: boolean;
    fullWidth?: boolean;
    target?: string;
    rel?: string;
    classNames?: string;
    children: React.ReactNode;
    iconVariant?: CtaIcon;
};

const iconMap: Record<CtaIcon, React.ReactNode> = {
    [CtaIcon.Back]: <IconChevronLeft />,
    [CtaIcon.Dealer]: <IconMarker />,
    [CtaIcon.Phone]: <IconPhone />,
    [CtaIcon.Reserve]: <IconReserve />,
    [CtaIcon.Buy]: <IconCartV2 />,
    [CtaIcon.Finance]: <IconCard />,
    [CtaIcon.Insurance]: <IconInsurance />,
};

/**
 * ButtonCta - Button Outline style with icon
 * @example
 *   <ButtonCta icon={iconVariant}>
 *     {label}
 *   </ButtonCta>
 */
const ButtonCta = (props: ButtonProps): JSX.Element => {
    const { key, href, onClick, disabled, fullWidth, children, target, classNames, rel, iconVariant } = props;

    return (
        <ButtonStyles.ButtonCta key={key} fullWidth={fullWidth}>
            <Text.Button
                as={href ? "a" : "button"}
                role={href ? "link" : "button"}
                href={href && !disabled ? href : undefined}
                type={!href ? "button" : undefined}
                className={[classNames || "", disabled ? "disabled" : ""].join(" ")}
                disabled={!href && disabled}
                aria-disabled={disabled || undefined}
                target={href ? target : undefined}
                rel={href && rel}
                onClick={onClick}
            >
                {iconVariant && <UspIconWrapper size={20}>{iconMap[iconVariant]}</UspIconWrapper>}
                <LineClamp lines={2}>{children}</LineClamp>
                <IconWrapper>
                    <IconArrowRight />
                </IconWrapper>
            </Text.Button>
        </ButtonStyles.ButtonCta>
    );
};

export default ButtonCta;
